import api from 'api';

export const loadAdminUsers = api('POST /api/users/grid');
export const loadUserDetails = api('GET /api/users/:id/details');

export const createUser = api('POST /api/users');
export const loadUser = api('GET /api/users/:id');
export const updateUser = api('PUT /api/users/:id');
export const blockUser = api('POST /api/users/:id/block');
export const unblockUser = api('POST /api/users/:id/unblock');
export const exportUsers = api('POST /api/users/export', {
  responseType: 'blob',
});
export const updatePermissions = api('POST /api/users/permissions');
export const checkUserUpdateStatus = api('GET /api/users/update/:jobId/status');
